import styled from 'styled-components';
import BGTile from '../images/dark-wave-bg.jpg';

const StyledSection = styled.section`
  min-height: 100vh;
  background: url(${BGTile});
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  color: white;
  
`

const FlexWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`

const NameHeading = styled.h1`
  font-size: 3rem;
  letter-spacing: .2rem;
  padding: 2rem 0;
  span:first-of-type {
    font-weight: 700;
    margin-right: 1rem;
  }
  span:last-of-type {
    font-weight: 200;
  }
  display: flex;
  flex-flow: row nowrap;
  @media (max-width: 580px) {
    flex-flow: column nowrap;
    align-items: center;
    font-size: 2.5rem;
    line-height: 3rem;
  }
`

const DescriptionWrapper = styled.div`
  border-top: white solid 1px;
  border-bottom: white solid 1px;
  padding: 2rem;
  max-width: 35rem;
  font-size: 1rem;
  p {
    padding: 1rem 0;
    line-height: 1.75rem;
    a {
      text-decoration: none;
      color: #3cb496;
    }
  }
`

const ContactWrapper = styled.div`
  padding: 2rem;
  h2 {
    text-align: center;
    font-weight: 700;
    letter-spacing: .1rem;
  }
  p {
    padding-top: 1rem;
    text-align: center;
  }
`

const ContactLink = styled.a`
  /* width: fit-content; */
  /* margin: 1rem auto; */
  font-size: 1rem;
  text-decoration: none;
  color: #3cb496;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  letter-spacing: .1rem;
  span {
    padding-left: 1rem;
  }
  padding-top: .5rem;
  padding-bottom: 2rem;
`

const SubheadingWrapper = styled.div`
  padding: 2rem;
  font-size: 1.5rem;
  font-weight: 200;
  letter-spacing: .2rem;
  border-top: white solid 2px;
  border-bottom: white solid 2px;
  text-align: center;
  line-height: 1.5rem;
  h2:first-child {
    padding-bottom: 1.5rem;
  }
  @media (max-width: 580px) {
    font-size: 1.2rem;
  }
`

const StyledNav = styled.nav`
  padding: 2rem;
`

const NavList = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  @media (max-width: 580px) {
    flex-flow: column nowrap;
  }
`

const NavLink = styled.a`
  display: inline-block;
  text-decoration: none;
  text-align: center;
  color: white;
  letter-spacing: .2rem;
  background: transparent;
  border: white solid 1px;
  border-radius: 5px;
  width: 7rem;
  height: 3rem;
  line-height: 3rem;
  font-size: .8rem;
  margin: 0 .25rem;
  :hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
  transition: background-color ease .3s;
  @media (max-width: 580px) {
    margin: 1rem 0;
  }
  cursor: pointer;
`

const ScrollBtn = styled.a`
  background: transparent;
  border: none;
  cursor: pointer;
  padding-bottom: 2rem;
`

const Intro = () => {

  return (
    <StyledSection>
      <FlexWrapper>
        <NameHeading>
          <span>JOE</span>
          <span>KIRCHHOFF</span>
        </NameHeading>
        <DescriptionWrapper>
          <p>
            Joe is a screenwriter living in Los Angeles. He loves to write high concept, genre-bending horror movies.
          </p>
          <p>
            He draws inspiration from his past lives as a neuroscience researcher, craft bartender, software developer, and crisis hotline counselor.
          </p>
          <p>
            He still makes a mean <a href='https://punchdrink.com/recipes/corpse-reviver-2/'>Corpse Reviver No. 2</a>.
          </p>
        </DescriptionWrapper>
        <ContactWrapper>
          <h2>
            CONTACT
          </h2>
          <ContactLink href="mailto:joe.elik@gmail.com">
            {/* Email Icon SVG */}
            <svg width="30" height="30" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16 22C14.6804 22 13.51 22.639 12.7815 23.6244C13.0832 23.7236 13.3709 23.8822 13.6271 24.1017L36.4207 43.6392C38.4804 45.4046 41.5197 45.4046 43.5794 43.6392L66.3731 24.1017C66.6292 23.8822 66.9169 23.7236 67.2185 23.6245C66.49 22.639 65.3196 22 64 22H16Z"
                fill="#ffffff"
              />
              <path
                d="M68 29.2926L46.8334 47.4354C42.9012 50.8059 37.0989 50.8059 33.1668 47.4354L12 29.2925V54C12 56.2091 13.7909 58 16 58H64C66.2091 58 68 56.2091 68 54V29.2926Z"
                fill="#ffffff"
              />
            </svg>
            <span>joe.elik@gmail.com</span>
          </ContactLink>
          <h2>
            MANAGEMENT
          </h2>
          <p>RANGE / Francis McDonough, Alain Carles</p>
        </ContactWrapper>
        {/* <SubheadingWrapper>
          <h2>FULL-STACK WEB DEVELOPER</h2>
          <h2>SCREENWRITER</h2>
        </SubheadingWrapper> */}
        {/* <StyledNav>
          <NavList>
            <li>
              <NavLink href='#about'>
                ABOUT
              </NavLink>
            </li>
            <li>
              <NavLink href='#skills'>
                SKILLS
              </NavLink>
            </li>
            <li>
              <NavLink href='#code-examples'>
                CODE
              </NavLink>
            </li>
            <li>
              <NavLink href='#contact'>
                CONTACT
              </NavLink>
            </li>
          </NavList>
        </StyledNav> */}
      </FlexWrapper>
      {/* <ScrollBtn href='#about' aria-label="scroll to about section">
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" transform='rotate(180)' xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.9629 44.1831L37.8416 22.3045C39.0131 21.1329 40.9126 21.1329 42.0842 22.3045L63.9629 44.1831"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.9629 60.1831L37.8416 38.3045C39.0131 37.1329 40.9126 37.1329 42.0842 38.3045L63.9629 60.1831"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ScrollBtn> */}
    </StyledSection>
  )
}

export default Intro